module.exports = __webpack_public_path__ + "media/images/pages/instagram_white-751786386859a202ad2bc5b9d048d984.png";